import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    supplierPmBox: {
      paddingTop: 60,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    connectStripBtn: {
      textAlign: 'center',
      width: 200,
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 600,
      height: 40,
      padding: '10px 15px',
      borderRadius: 24,
      borderWidth: 2,
      borderStyle: 'solid',
      lineHeight: '16px',
      marginLeft: 5,
      marginRight: 5,
      color: colorVariables.white,
      backgroundColor: colorVariables.green,
    },
    loginStripBtn: {
      textAlign: 'center',
      display: 'inline-flex',
      width: 200,
      textTransform: 'none',
      alignItems: 'center',
      fontSize: 16,
      fontWeight: 600,
      height: 48,
      padding: '5px 15px',
      borderRadius: 8,
      borderWidth: 2,
      borderStyle: 'solid',
      lineHeight: '16px',
      marginLeft: 5,
      marginRight: 5,
      color: colorVariables.white,
      backgroundColor: '#635bff',
      cursor: 'pointer',
      transition: 'all ease-in-out 0.5s',
      '& span': {
        paddingLeft: 20,
      },
      '&:hover': {
        scale: 1.06,
        opacity: 0.8,
      },
    },
    stripeTitle: {
      fontSize: 18,
      lineHeight: '28px',
      fontWeight: 700,
      marginBottom: 20,
      textAlign: 'center',
    },
    stripeSubText: {
      color: colorVariables.grey80,
      marginBottom: 40,
      textAlign: 'center',
    },
    hiddenLink: {
      opacity: 0,
      fontSize: 0,
    },
  }),
);
